function toggleCart() {
  const container = document.querySelector('#CartContainer')
  if (container.classList.contains('is-open')) {
    container.querySelector('.cart').style.transform = 'translateX(100%)'
    setTimeout(() => {
      container.classList.remove('is-open')
      document.body.style.overflow = ''
      document.body.classList.remove('upcartPopupShow')
    }, 350)
  } else {
    container.classList.add('is-open')
    document.body.style.overflow = 'hidden'
    setTimeout(() => {
      container.querySelector('.cart').style.transform = 'translateX(0%)'
    }, 0)
  }
}

let productObserver = null
let hasSetupListener = false

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('#AddToCart')) {
      productObserver = new MutationObserver((mutations) => {
          if (!hasSetupListener) {
            let baseAddToCart = []

            document.querySelector('#AddToCart').onclick = () => {
              
              if (document.querySelector('#AddToCart').getAttribute('disabled') === 'disabled') {
                return
              }
              document.querySelector('#AddToCart').classList.add('adding');
              const id = document.querySelector('select[name="id"]').value;
              const name = document.querySelector('.product-details-product-title').textContent + ' - ' + document.querySelector('select[name="id"] option:checked').textContent.split(' -')[0]
;
              const radio = document.querySelector('#bold_options_div input[type=radio]')

              if (document.querySelector('#bold_options_div') &&
                radio?.checked) {
                const boldEle = document.querySelector('#bold_options_div .bold_option_textbox input')

                var warningElement = document.getElementById('tempWarning');
                if (warningElement) {
                  warningElement.remove();
                }


                if (!boldEle.value) {
                  var boldOptionElement = document.querySelector('.bold_option_textbox .bold_option_element');
                  var spanElement = document.createElement('span');
                  spanElement.textContent = 'Please enter initials';
                  spanElement.style.color = '#ad0000';
                  spanElement.id = 'tempWarning';
                  boldOptionElement.appendChild(spanElement);

                  return
                }
                baseAddToCart = [
                  {
                    id,
                    quantity: 1,
                    //[radio.getAttribute('name')]: radio.value,
                    //[boldEle.getAttribute('name')]: boldEle.value,
                    properties: {
                      'Has Monogramming': 'Yes',
                      'Initials (Capital letters only)*': boldEle.value,
                    },
                    //['properties[Has Monogramming]']: 'Yes',
                    //[boldEle.getAttribute('name')]: boldEle.value,
                  },
                  {
                    id: document.querySelector('input[name="properties[_boldVariantIds]"]').value,
                    properties: {
                      'Initials (Capital letters only)*': boldEle.value,
                      'Key Organiser': name,
                    },
                    //[boldEle.getAttribute('name')]: boldEle.value,
                    //['properties[Key Organiser]']: name
                  }
                ];
                if (document.querySelector('input[name="properties[PreOrder]"]') && document.querySelector('input[name="properties[PreOrder]"]').value) {
                  baseAddToCart[0].properties = {
                    'PreOrder': document.querySelector('input[name="properties[PreOrder]"]').value,
                  };
                }

              } else {
                baseAddToCart = [
                  {
                    id,
                    quantity: 1,
                  },
                ]
                if (document.querySelector('input[name="properties[PreOrder]"]') && document.querySelector('input[name="properties[PreOrder]"]').value) {
                  baseAddToCart[0].properties = {
                    'PreOrder': document.querySelector('input[name="properties[PreOrder]"]').value,
                  };
                }
              }

              let productFreeGift = document.querySelector('product-free-gift')
              if (productFreeGift) {
                baseAddToCart.push({
                  id: productFreeGift.getAttribute('data-gift-id'),
                  quantity: 1
                })
              }

              // CHECK AND ADD SELECTED EXTENSION TO CART
              var extensionProducts = document.querySelectorAll('.product-extension-item__product-variant.selected:not(.product-extension-item__product-variant-none');
              extensionProducts.forEach(function(extensionProduct){
                var variantID = extensionProduct.getAttribute('data-variant');
                var isPreOrder = extensionProduct.querySelector('.product-extension-item__pre-order') !== null;
                var shipDate = extensionProduct.querySelector('.product-extension-item__pre-order-date')?extensionProduct.querySelector('.product-extension-item__pre-order-date').textContent:'Ship date will be updated.';
                var extensionItem = {
                  id: variantID,
                  quantity: 1
                };
                if (isPreOrder) {
                  extensionItem.properties = {
                    'PreOrder': shipDate,
                  }
                }
                //console.log(variantID);
                if (variantID) {
                  baseAddToCart.push(extensionItem);
                }
              });

              CartJS.addItems(baseAddToCart, {
                success: () => {
                  setTimeout(function(){
                    document.querySelector('#AddToCart').classList.remove('adding');
                  },300);
                },
                error: (err) => {
                  console.error('Add to cart failed:', err);
                  setTimeout(function(){
                    document.querySelector('#AddToCart').classList.remove('adding');
                  },300);
                }
              })
            }
          }
        }
      )
      productObserver.observe(document.querySelector('.product-form-vue'), {
        subtree: true,
        childList: true,
        attributes: true
      })
    }

    document.querySelectorAll(['.site-header__cart-toggle', '.cart__underlay', '.close-cart']).forEach(item => item.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()
      toggleCart()
    }))
  }
)

if (!customElements.get('open-cart')) {
  customElements.define('open-cart', class OpenCart extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', () => {
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.price-remove .remove').addEventListener('click', (event) => {
        event.target.classList.add('free-gift-loading')

        CartJS.removeItem(event.target.closest('cart-item').getAttribute('data-line'))
      })

      this.querySelector('.qty-wrapper .minus').addEventListener('click', () => {
        this.querySelector('input').stepDown()
        this.updateQuantity()
      })
      this.querySelector('.qty-wrapper .plus').addEventListener('click', () => {
        this.querySelector('input').stepUp()
        this.updateQuantity()
      })
    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        this.querySelector('.price-remove .remove').classList.add('free-gift-loading')
        CartJS.updateItem(this.getAttribute('data-line'), this.querySelector('input').value)
        this.timeout = null
      }, 300)
    }
  })
}

if (!customElements.get('cart-header')) {
  customElements.define('cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.close-cart').addEventListener('click', event => {
        toggleCart()
      })
    }
  })
}


let previousCartState = null;
// Fetch the current cart data
function fetchCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(currentCart => {
      if (previousCartState) {
        checkForRemovedItems(previousCartState, currentCart);
      }
      syncCartAttributes(currentCart);
      previousCartState = currentCart; // Update the previous cart state
    });
}

// Poll the cart periodically to detect changes
setInterval(fetchCart, 5000);

function getDiscountedItems(cart) {
  return cart.items
    .filter(item => {
      if (!item.discounts || item.discounts.length === 0) return false;

      return item.discounts.some(discount => {
        const title = discount.title.toLowerCase();
        return title.includes('spend') && title.includes('free');
      });
    })
    .map(item => item.product_id);
}

function syncCartAttributes(cart) {
  // 1. Build discount_freegift string
  const ids = getDiscountedItems(cart);
  const discountFreeGift = ids.join(',');
  // 2. Compare total_discount
  const currentTotalDiscount = cart.total_discount || 0;
  const attrTotalDiscount = Number(cart.attributes?.total_discount || 0);

  // 3. Prepare new attributes object
  const newAttributes = { ...cart.attributes };
  let needUpdate = false;

  if (!newAttributes.discount_freegift) newAttributes.discount_freegift = '';
  if (newAttributes.discount_freegift !== discountFreeGift) {
    newAttributes.discount_freegift = discountFreeGift;
    needUpdate = true;
  }

  if (currentTotalDiscount !== attrTotalDiscount) {
    newAttributes.total_discount = String(currentTotalDiscount);
    needUpdate = true;
  }

  // 4. Update if needed
  if (needUpdate) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: newAttributes })
    })
    .then(res => res.json())
    .then(updatedCart => {
      console.log('Cart attributes synced:', updatedCart.attributes);
    });
  }
}

// Compare the previous cart with the current one to find removed items
function checkForRemovedItems(prevCart, currCart) {
  const prevItems = prevCart.items.map(item => item.key);
  const currItems = currCart.items.map(item => item.key);

  // Find the item(s) removed by comparing the two arrays
  const removedItems = prevItems.filter(key => !currItems.includes(key));

  if (removedItems.length > 0) {
    removedItems.forEach(removedItem => {
      // Find the full item details by variant_id from the previous cart
      const removedItemDetails = prevCart.items.find(item => item.key === removedItem);
      
      if (removedItemDetails.properties['Has Monogramming'] == 'Yes') {
        // KO with Monogramming removed
        const propertiesToRemove = {
          'Key Organiser': removedItemDetails.title,
          'Initials (Capital letters only)*': removedItemDetails.properties['Initials (Capital letters only)*'],
        };
        removeItemByProperties(propertiesToRemove);
      } else if (removedItemDetails.properties['Initials (Capital letters only)*'] != '') {
        // Monogramming removed
        const propertiesToRemove = {
          'Has Monogramming': 'Yes',
          'Initials (Capital letters only)*': removedItemDetails.properties['Initials (Capital letters only)*'],
        };
        const newProperties = {
          'Has Monogramming': 'No',
        }; // Clear old properties
        updateItemProperties(propertiesToRemove,newProperties);
      }
    });
  }
}

function updateItemProperties(properties,newProperties) {
  // Fetch the current cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Iterate through the cart items
      cart.items.forEach((item,index) => {
        // Check if the item has the specified properties
        const matchesAllProperties = Object.keys(properties).every(propertyName => {
          return item.properties && item.properties[propertyName] === properties[propertyName];
        });

        // If all properties match, remove the item's properties
        if (matchesAllProperties) {
          //console.log(item);
          updateCartItemPropertiees(item.key, newProperties)
          setTimeout(function(){
            CartJS.updateItem(index+1, item.quantity);
          },1000);
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

function removeItemByProperties(properties) {
  // Fetch the current cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Iterate through the cart items
      cart.items.forEach(item => {
        // Check if the item has the specified properties
        const matchesAllProperties = Object.keys(properties).every(propertyName => {
          return item.properties && item.properties[propertyName] === properties[propertyName];
        });
        // If all properties match, remove the item
        if (matchesAllProperties) {
          //console.log(item);
          CartJS.removeItemById(item.key);
        }
      });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

// Remove the item from the cart by variant ID or line ID
function updateCartItemPropertiees(key, properties) {
  let data = {
      "id" : key,
      "properties" : properties
  }
  let cartContents = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
  })
  .then(response => {
      return response.json();
  })
  .then(cart => {
    // Optionally, refresh the cart UI or trigger custom events here
  })
  .catch((error) => {
      console.error('Error:', error);
  })
}

// Remove the item from the cart by variant ID or line ID
function removeCartItem(key) {
  let data = {
      "id" : key,
      "quantity" : 0
  }
  console.log(data);

  let cartContents = fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
  })
  .then(response => {
      return response.json();
  })
  .then(cart => {
    // Optionally, refresh the cart UI or trigger custom events here
  })
  .catch((error) => {
      console.error('Error:', error);
  })
}
